var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#C6D1D3"
    },
    d: "M462.886,438.36c0,2.903-42.988,5.256-96.016,5.256 c-53.028,0-96.016-2.353-96.016-5.256c0-2.903,42.988-5.256,96.016-5.256C419.898,433.105,462.886,435.458,462.886,438.36z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M310.737,287.921c-0.179-0.197-1.683,1.166-3.327-2.578c-0.346-0.789-0.492-1.9-0.355-2.75 c0.86-5.315,4.339-7.432,7.123-9.418c5.627-4.014,21.982-4.664,18.266,19.507L310.737,287.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAC5A5"
    },
    d: "M313.943,293.997l-0.41,2.621c-0.063,0.405,0.362,0.709,0.725,0.518l1.916-1.011 L313.943,293.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAC5A5"
    },
    d: "M334.424,304.305L334.424,304.305c-1.795,0.947-3.762,2.221-4.709,0.426l-4.31-6.298l7.88-4.159 l2.674,5.066C336.906,301.135,336.219,303.358,334.424,304.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAC5A5"
    },
    d: "M327.128,298.977l7.379-2.388l-11.101-21.032l-15.012,7.924l6.368,12.065 C317.375,300.498,322.175,301.591,327.128,298.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#5F7EFB",
      strokeWidth: 0.6165,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M314.362,292.741c0,0,1.497,0.327,2.071-1.093"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M314.706,282.677c0,0,0.779,3.478,5.427,4.517l2.513,2.977l4.97-1.022l-3.74-10.334 L314.706,282.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M326.703,290.418c0,0,2.055-0.272,5.741,2.264l-4.482-17.31l-7.688-2.062l-3.498,5.433 L326.703,290.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAC5A5"
    },
    d: "M327.417,286.842c0.769,1.456,0.211,3.26-1.245,4.029s-3.26,0.211-4.029-1.245 c-0.769-1.456-0.211-3.26,1.245-4.029S326.648,285.386,327.417,286.842z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B999"
    },
    d: "M326.109,299.463c0,0,3.956-3.815,3.865-6.806c0,0,0.198,5.917-2.847,8.294L326.109,299.463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M314.706,282.677c0,0-0.11,3.28-4.703,4.525l-2.949-4.609l10.506-6.915l6.315,3.138l-0.199,4.578 L314.706,282.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.6576,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M312.641,289.593c0,0,0.655-2.078,3.135-1.548"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F7EFB"
    },
    d: "M352.078,354.459l3.928,31.128l24.87,31.375l-9.36,8.988l-25.965-30.972 c-0.573-0.714-1.041-1.507-1.387-2.354l-9.188-24.833L352.078,354.459z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC8A2"
    },
    d: "M297.9,314.536c-0.913,2.709,0.543,5.645,3.252,6.558c2.709,0.913,5.645-0.543,6.558-3.252 c0.914-2.709-0.543-5.645-3.251-6.558C301.749,310.371,298.813,311.827,297.9,314.536z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290.846,305.765L290.846,305.765c-0.334,0.499-0.199,1.182,0.3,1.516l14.242,9.558c0.499,0.335,1.181,0.2,1.515-0.3 l0,0c0.335-0.499,0.2-1.182-0.3-1.516l-14.241-9.558C291.862,305.13,291.18,305.265,290.846,305.765z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC8A2"
    },
    d: "M329.835,309.98l-8.519,19.562l-14.87-11.817l-3.767,3.615l19.324,18.221 c1.278,0.977,3.111,0.701,4.045-0.609l9.241-12.963L329.835,309.98z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBF75F"
    },
    d: "M334.132,300.507c0,0-6.815,0.932-9.278,14.604c-2.462,13.672,3.023,36.519,3.023,36.519 l24.012-2.036l-5.935-44.235C345.954,305.36,340.928,295.401,334.132,300.507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F7EFB"
    },
    d: "M328.077,351.595v7.018l-15.719,28.157c-0.457,0.871-0.746,1.819-0.855,2.796l-3.501,40.143 l11.888,3.639l4.904-38.295l24.116-31.082c0,0,5.267-6.57,3.169-14.539L328.077,351.595z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308.001,429.71l-9.257,0.889c-2.376,0.228-4.508,1.553-5.763,3.583l0,0c-0.237,0.382-0.021,0.883,0.419,0.974 l21.517,4.445c0.361,0.075,0.711-0.167,0.77-0.531l1.067-6.681L308.001,429.71z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M371.396,425.626l-4.035,8.379c-1.035,2.15-1.006,4.66,0.078,6.785v0c0.205,0.4,0.745,0.475,1.05,0.146l14.602-15.852 c0.251-0.27,0.225-0.695-0.056-0.933l-4.813-4.625L371.396,425.626z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3475d"
    },
    d: "M391.544,382.961l2.56,2.507l3.231-3.231l-2.708-2.511c-0.9-0.835-2.305-0.787-3.146,0.107l0,0 C390.646,380.72,390.675,382.11,391.544,382.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3475d"
    },
    d: "M417.492,388.883l-2.878,3.047l30.132,29.428l3.158-3.218c1.155-1.176,1.127-3.068-0.061-4.211 L421.7,388.782C420.513,387.64,418.623,387.686,417.492,388.883z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.63,
    y: 351.31,
    transform: "matrix(0.7009 -0.7132 0.7132 0.7009 -153.6047 379.353)",
    style: {
      fill: "#B7C2C4"
    },
    width: 1.801,
    height: 43.043
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9764"
    },
    d: "M360.781,358.41c-0.935,0.936-2.453,0.936-3.388,0c-0.936-0.936-0.936-2.453,0-3.388 c0.935-0.936,2.453-0.936,3.388,0C361.717,355.957,361.717,357.474,360.781,358.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3475d"
    },
    d: "M386.522,391.212l13.627-12.265c1.924-1.732,4.862-1.667,6.71,0.146l37.048,36.382 c1.922,1.888,1.959,4.973,0.084,6.906l-13.66,14.081L386.522,391.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383635"
    },
    d: "M436.961,433.641c0,3.607-2.924,6.531-6.53,6.531c-3.607,0-6.531-2.924-6.531-6.531 c0-3.606,2.924-6.53,6.531-6.53C434.037,427.111,436.961,430.035,436.961,433.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6EBE6"
    },
    d: "M433.169,433.641c0,1.512-1.226,2.739-2.738,2.739c-1.513,0-2.739-1.226-2.739-2.739 c0-1.512,1.226-2.738,2.739-2.738C431.943,430.903,433.169,432.129,433.169,433.641z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC8A3"
    },
    d: "M354.648,358.691c1.09,2.452,3.962,3.555,6.414,2.464c2.452-1.091,3.555-3.962,2.464-6.414 c-1.09-2.452-3.962-3.555-6.414-2.464C354.66,353.368,353.557,356.239,354.648,358.691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC8A2"
    },
    d: "M347.285,322.635l8.563,12.465l0.658,18.835l5.049-0.12l2.315-19.582 c0.151-1.034-0.029-2.089-0.514-3.015l-7.477-13.501L347.285,322.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBF75F"
    },
    d: "M340.011,299.35c3.904,1.48,12.396,7.385,19.077,19.587l-11.913,9.003 c0,0-10.632-11.007-11.937-19.385C334.531,304.032,335.869,297.78,340.011,299.35z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#EFBF6D",
      strokeWidth: 0.7055,
      strokeMiterlimit: 10
    },
    d: "M348.923,326.817l-1.749,1.123 c0,0-9.38-6.816-11.647-18.005"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.9caa800296cea0e8b6ed9e8517b6daaf.svg";
export { ForwardRef as ReactComponent };